<template>
	<div>
        <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

        <van-tabs
            type="card"
            color="#ffffff"
            background="#aaaaaa"
            title-inactive-color="#000000"
            title-active-color="#000000"
            @click="tabsClick"
        >
            <van-tab title="装车扫描"></van-tab>
            <van-tab title="拍照"></van-tab>
        </van-tabs>
        
        <!-- 装车扫描 -->
        <div v-if="tabType === '装车扫描'">
            <!-- 车辆信息 -->
            <div>
                <p class="p-title">车辆信息</p>
                <div class="item-info">
                    <ul class="item-ul">
                        <li class="item-li">
                            <div class="item-left">
                                <span>车牌号码</span><span>{{list.carNumber}}</span>
                            </div>
                        </li>
                        <li class="item-li">
                            <div class="item-left">
                                <span>司机姓名</span><span>{{list.driver}}</span>
                            </div>
                        </li>
                        <li class="item-li">
                            <div class="item-left">
                                <span>联系方式</span><span>{{list.driverPhone}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 临柜信息 -->
            <div>
                <p class="p-title">装车单信息【{{list.loadCarNo}}】</p>
                <div class="item-info">
                    <ul class="item-ul">

                        <li class="item-li">
                            <div class="item-left">
                                <span>参考单号</span><span>{{list.referenceNo}}</span>
                            </div>
                        </li>
                        <li class="item-li">
                            <div class="item-left">
                                <span>柜型</span><span>{{list.containerType}}</span>
                            </div>
                        </li>
                        <li class="item-li">
                            <div class="item-left">
                                <span>订舱号（SO号）</span><span>{{list.soNumber}}</span>
                            </div>
                        </li>
                        <li class="item-li">
                            <div class="item-left">
                                <span>封条号</span><span>{{list.sealNumber}}</span>
                            </div>
                             <div class="item-left">
                                <span>运输方式</span><span>{{list.transportType}}</span>
                            </div>
                        </li>
                        <li class="item-li">
                            <div class="item-left">
                                <span>柜号</span><span>{{list.containerNumber}}</span>
                            </div>
                            <div class="item-right">
                                <span>总箱数</span
                                ><span>{{list.boxCount}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

   <!-- 备注信息 -->
            <div>
                <p class="p-title">备注信息</p>
                <div class="item-info">
                    <ul class="item-ul">
                        <li @v-if="list.remarkList.length>0"  class="item-li"   v-for="(item,i) in list.remarkList.slice(0,2)" :key="i">
                                <div>{{item}}</div>
                        </li>
                        <li class="item-li"  v-if="list.remarkList.length>2">
                                <div v-if="!isOpen">...</div>
                        </li>
                        <li  @v-if="list.remarkList.length>0"  class="item-li"  v-for="(item,i) in list.remarkList.slice(2)" :key="i">
                                <div v-if="isOpen">{{item}}</div>
                        </li>
                        
                       
                    </ul>
                    
                </div>
                <div>
                  <ul class="item-ul">
                         <li class="item-li" v-if="list.remarkList.length>2" style="float:right;color: blue;">
                                <a @click="openOrclose()">{{isOpen?'收起':'展开'}} </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="search-box">
                <van-field
                    size="small"
                    v-model="scanBoxCode"
                    placeholder="请扫码装车箱码"
                    right-icon="scan"
                    :center="true"
                    :border="false"
                    clear-trigger="always"
                    clearable
                    @click-right-icon="scan(0)"
                    @keyup.13="getBoxCode()"
				    @keyup="inputNum"
                    @focus="focusInp('scanBoxCode')"
                    ref="scanInp1"
                />
                
                <div class="isAllSendBox">
                    <van-checkbox v-model="isAllSendBox" shape="square">全部发货</van-checkbox>
                </div>
            </div>

            <div>
                <p class="p-title">发货统计</p>
                <div>
                    <van-row type="flex" justify="center" align="center">
                        <van-col span="12" style="background-color: #95f204;" @click="toList(true)">已扫箱数 {{list.scanBoxCount}}</van-col>
                        <van-col span="12" style="background-color: #ec808d;" @click="toList(false)">未扫箱数 {{list.noScanBoxCount}}</van-col>
                    </van-row>
                </div>
        
            </div>

            <!-- 未发箱号搜索 -->
            <div>
                <p class="p-title">未发箱号</p>

                <div class="search-box">
                    <van-field
                        size="small"
                        v-model="scanNoSendBoxCode"
                        placeholder="请扫码不发箱码"
                        right-icon="scan"
                        :center="true"
                        :border="false"
                        clear-trigger="always"
                        clearablegit
                        @click-right-icon="scan(1)"
                        @keyup.13="getNoSendBoxCode()"
				        @keyup="inputNum"
                        @focus="focusInp('scanNoSendBoxCode')"
                        ref="scanInp2"
                    />
                </div>
            </div>

            <!-- 未发箱号列表 -->
            <div class="noSend-list" v-if="noSendList.length">
                <div>
                    <van-row type="flex" justify="center" align="center" class="noSend-list-item" v-for="(item,i) in noSendList" :key="i">
                        <!-- <van-col span="20" class="noSend-list-left"> {{ item.boxNo ? `${item.destinationBoxNo}` : `${item.wmsBoxNo})` }}</van-col> -->
                        <van-col span="20" class="noSend-list-left"> {{ `${item.wmsBoxNo}` }}</van-col>
                        <van-col span="4" class="noSend-list-right" @click="delBox(item.recordId)">删除</van-col>
                    </van-row>
                </div>
            </div>

            <!-- 提交 -->
            <div class="putC_footer">
                <button class="submit-btn" @click="submit">提交</button>
                <button class="submit-btn clear-btn" @click="clearAll">清空重扫</button>
            </div>
        </div>

        <!-- 拍照 -->
        <div v-else>
            
            <div class="photo">
                <p class="p-title" style="border-bottom: 1px solid #ececec;">装车照片</p>
                <div class="sign-photo-cpntent">
                    <div class="sign-photo-box">
                        <ul v-for="(item,i) in photoList" :key="i">
                            <div v-for="(item2,i2) in item" :key="i2">
                                <p><span class="red" v-if="item2.required">*</span>{{item2.text}}</p>
                                <div
                                    class="sign-photo-item"
                                    v-if="imgObj[item2.name]"
                                >
                                    <span
                                        class="delete-icon"
                                        @click="deleteImg(item2.name)"
                                        >x</span
                                    >
                                    <img
                                        :src="imgObj[item2.name]"
                                        class="sign-photo-item-img"
                                        alt=""
                                        @click="previewImage(imgObj[item2.name])"
                                    />
                                </div>

                                <div class="sign-photo-btn" v-else>
                                    <div class="photo">
                                        <input
                                            class="img hidden"
                                            @change="changeImg"
                                            type="file"
                                            name="cover"
                                            ref="inputer"
                                            accept="image/*"
                                        />
                                        <p @click="chooseImage(item2.id)">
                                            <i class="el-icon-camera"></i>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </ul>
                    </div>

                    <div class="sign-photo-save">
                        <button class="submit-btn" @click="submit">提交</button>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import { Icon, Badge, Picker, Popup, Field, Toast, Empty, List, Loading, Checkbox, Tab, Tabs,SwipeCell, Col, Row,Button,Cell,Dialog,ImagePreview,Sticky } from 'vant';
import { mixins } from "../mobileMixins";
import { mapMutations } from 'vuex'
import { AllBoxDelivery,GetPutOnCarListByContainerNo,GetPutOnCarLoadingReviewImageListType,ScanCodeDeliveryBox,ScanCodeNoDeliveryBox,DeleteScanBoxInfo,PutOnCarSubmit,ClearScanAllBoxInfo } from '@/api/mobile/loading_api';
import { BaseApiUrl } from '@/api/axios_config';
import axios from 'axios';
import {isMobileTerminal} from "util/validate";
export default {
	data() {
		return {
			list: {},
            isOpen:false,
            tabType: '装车扫描',
            scanBoxCode:'',
            scanNoSendBoxCode:'',
            isAllSendBox: false,
            noSendList:[],

            currentImg: '',
            imgObj:{     // 图片类型 1.车牌照 2.空柜照 3.托运单 4.未关门照 5.半关门照 6关门照 7.锁封照 8.其他 9.其他1
                img1:'',
                img2:'',
                img3:'',
                img4:'',
                img5:'',
                img6:'',
                img7:'',
                img8:'',
                img9:'',
            },
            photoList:[ 
                [
                    {
                        name:'img1',
                        text:'车牌照',
                        id: 1,
                        required:false
                    },
                    {
                        name:'img2',
                        text:'空柜照',
                        id: 2,
                        required:false
                    },
                    {
                        name:'img3',
                        text:'托运单',
                        id: 3,
                        required:false
                    },
                ],
                [
                    {
                        name:'img4',
                        text:'未关门照',
                        id: 4,
                        required:false
                    },
                    {
                        name:'img5',
                        text:'半关门照',
                        id: 5,
                        required:false
                    },
                    {
                        name:'img6',
                        text:'关门照',
                        id: 6,
                        required:false
                    },
                ],
                [
                    {
                        name:'img7',
                        text:'锁封照',
                        id: 7,
                        required:false
                    },
                    {
                        name:'img8',
                        text:'其他',
                        id: 8,
                        required:false
                    },
                    {
                        name:'img9',
                        text:'其他1',
                        id: 9,
                        required:false
                    },
                ],
            ],
            imgFiles: [],
            saveImgUrlArr:[],
            inpType:''
		}
	},	
    components: {
		[Icon.name]: Icon,
		[Badge.name]: Badge,
		[Picker.name]: Picker,
		[Popup.name]: Popup,
		[Toast.name]: Toast,
		[List.name]: List,
		[Empty.name]: Empty,
		[Loading.name]: Loading,
		[Checkbox.name]: Checkbox,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
		[SwipeCell.name]: SwipeCell,
		[Col.name]: Col,
		[Row.name]: Row,
		[Button.name]: Button,
		[Cell.name]: Cell,
    	[Dialog.Component.name]: Dialog.Component,
		[ImagePreview.name]: ImagePreview,
		[Sticky.name]: Sticky,
		[Field.name]: Field
	},
	mixins: [mixins],

    created(){
		this.init()
    },

	methods: {
		init() {
			this.getDetail()
            this.getImageList();
		},

        getDetail(){
			const data = {
				loadCarInfoID:this.$route.query.loadCarInfoID
			}

			GetPutOnCarListByContainerNo(data).then(res => {
				if (res.status === 200) {
					const { response } = res

					this.list = response


                    this.curTransportType = response.transportType
                    
                    this.handleImgRequired()
                    
                    this.noSendList = response.scanNoDeliveryBoxList || []
				} else {
					Toast.fail(res.msg);
				}
			})
        },

        getImageList(){
            var that=this;
                  GetPutOnCarLoadingReviewImageListType({loadCarInfoID:this.$route.query.loadCarInfoID}).then(res => {
				    var imageData=res.response;
                   
                    that.saveImgUrlArr=[];
                     if(imageData!=null){

                        

                         imageData.forEach((item,i)=>{
                             
                              that.saveImgUrlArr.push({imageUrl:item.fileUrl,imageType:item.imageType})

                             if(item.imageType==1){
                                  that.imgObj.img1=  `data:image/png;base64,${item.imageData}`;
                             }
                             if(item.imageType==2){
                                  that.imgObj.img2=`data:image/png;base64,${item.imageData}`;
                             }
                             if(item.imageType==3){
                                  that.imgObj.img3=`data:image/png;base64,${item.imageData}`;
                             }
                             if(item.imageType==4){
                                  that.imgObj.img4=`data:image/png;base64,${item.imageData}`;
                             }
                             if(item.imageType==5){
                                  that.imgObj.img5=`data:image/png;base64,${item.imageData}`;
                             }
                             if(item.imageType==6){
                                  that.imgObj.img6=`data:image/png;base64,${item.imageData}`;
                             }
                            if(item.imageType==7){
                                  that.imgObj.img7=`data:image/png;base64,${item.imageData}`;
                             }
                            if(item.imageType==8){
                                  that.imgObj.img8=`data:image/png;base64,${item.imageData}`;
                            }
                            if(item.imageType==9){
                                  that.imgObj.img9=`data:image/png;base64,${item.imageData}`;
                            }
               
                         })
                     }
                    
			})
        },

		tabsClick(n, t) {
			this.tabType = n === 0 ? '装车扫描' : '拍照'
            console.log(this.saveImgUrlArr);
		},

        focusInp(type){
            this.inpType = type
        },

		scan(type) {
			let that = this
			this.$wx.scanQRCode({
				needResult: 1,
				desc: 'scanQRCode desc',
				success: function (a) {
                    if(type === 0){
                        that.scanBoxCode = a.resultStr
                        that.getBoxCode()
                    }else{
                        that.scanNoSendBoxCode = a.resultStr
                        that.getNoSendBoxCode()
                    }
				}
			})
		},

		inputNum(target){
			let timeNow = target.timeStamp
			this.scanArr.push(timeNow)
			for(let i in this.scanArr){
				if(Math.ceil(this.scanArr[this.scanArr.length-1]) - Math.ceil(this.scanArr[this.scanArr.length-2])<30){
                    //if(this.inpType == 'scanBoxCode'){
					    // this.$refs.scanInp1.blur()
                    /**
                     * if(this.inpType == 'scanBoxCode'){
					    this.$refs.scanInp1.blur()
                    }
                    if(this.inpType == 'scanNoSendBoxCode'){
					    this.$refs.scanInp2.blur()
                    }
                     */
				}
			}
		},
        
        getBoxCode(){
            if(!this.scanBoxCode) return;
            
            ScanCodeDeliveryBox({scanCode:this.scanBoxCode,loadCarInfoID:this.$route.query.loadCarInfoID}).then(res=>{

				if (res.status === 200) {
                    this.getDetail()
				} else {
					Toast.fail(res.msg);
				}
                this.scanBoxCode='';
				this.$refs.scanInp1.focus()
            })
        },

        getNoSendBoxCode(){
            if(!this.scanNoSendBoxCode) return;

            ScanCodeNoDeliveryBox({scanCode:this.scanNoSendBoxCode,loadCarInfoID:this.$route.query.loadCarInfoID}).then(res=>{

				if (res.status === 200) {
                    this.getDetail()
				} else {
					Toast.fail(res.msg);
				}
            })
            this.scanNoSendBoxCode='';
			this.$refs.scanInp2.focus()
        },

        delBox(id){

			Toast.loading({
				message: '删除中...',
				forbidClick: true,
				overlay:true,
				duration:0
			});
            
            DeleteScanBoxInfo({recordId:id}).then(res=>{
                Toast.clear()
				if (res.status === 200) {
                    this.getDetail()
				} else {
					Toast.fail(res.msg);
				}
            })
        },

        checkPhoto(){
            const that = this

            if(this.curTransportType=="海运"||this.curTransportType=="空运"){
            if(!this.saveImgUrlArr.length){
                this.showsound(false);
                Toast('请上传带*号的必填图片')
                return false
             }
            }

            let flag = false
            this.photoList.forEach((item,i)=>{
                item.forEach((item2,i2)=>{
                    let arr = []
                    this.saveImgUrlArr.forEach((item3,i)=>{
                        arr.push(item3.imageType)
                    })
                    if(item2.required && !arr.includes(item2.id)){
                        flag = true
                    }
                })
            })
            if(flag){
                this.showsound(false);
                this.$message({
                    message: "请上传带*号的必填图片",
                    type: "error",
                });
                return false
            }

            
            // function fn(num){
            //     let flag = false
            //     that.saveImgUrlArr.forEach((item,i)=>{
            //         if(num === item.imageType){
            //             flag = true
            //         }
            //     })
            //     return flag
            // }

            // if(!fn(1)){
            //     Toast('请上传车牌照')
            //     return false
            // }else if(!fn(2)){
            //     Toast('请上传空柜照')
            //     return false
            // }else if(!fn(3)){
            //     Toast('请上传托运单')
            //     return false
            // }else if(!fn(4)){
            //     Toast('请上传未关门照')
            //     return false
            // }else if(!fn(5)){
            //     Toast('请上传半关门照')
            //     return false
            // }else if(!fn(6)){
            //     Toast('请上传关门照')
            //     return false
            // }else if(!fn(7)){
            //     Toast('请上传锁封照')
            //     return false
            // }else if(!fn(8)){
            //     Toast('请上传其他')
            //     return false
            // }else if(!fn(9)){
            //     Toast('请上传其他1')
            //     return false
            // }
            return true
        },
showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
        submit(){
            const that = this
            
            if(this.list.scanBoxCount != this.list.boxCount) 
            {
                this.showsound(false);
                return Toast('已扫箱数必须等于总箱数');
            }
            if(!this.checkPhoto()) return;

			const data = {
                loadCarInfoID: this.$route.query.loadCarInfoID,
                imageUrls: this.saveImgUrlArr
			}

			Toast.loading({
				message: '提交中...',
				forbidClick: true,
				overlay:true,
				duration:0
			});

			PutOnCarSubmit(data).then(res => {
                Toast.clear()
				if (res.status === 200) {
                    this.showsound(true);
					Toast.success(res.msg || '提交成功');
                    
					setTimeout(function(){
                        that.$router.go(-1)
                    },1500)
				} else {
                    this.showsound(false);
					Toast.fail(res.msg);
				}
			})
        },

        // 全部发货
        allSend(){
            const that = this
            Dialog.confirm({
                title: '全部发货',
				confirmButtonText: '确定',
				cancelButtonText: '取消',
                message: '确认进行全部发货操作吗？',
            })
            .then(() => {
                AllBoxDelivery({LoadCarInfoID:this.list.loadCarInfoID}).then(res=>{
                    if (res.status === 200) {
                        this.showsound(true);
                        Toast.success(res.msg);
                        that.getDetail()
                    } else {
                        this.showsound(false);
                        Toast.fail(res.msg);
                        that.isAllSendBox = false
                    }
                })
            })
            .catch(() => {
                that.isAllSendBox = false
            });
        },

        // 清空重扫
        clearAll(){
            const that = this
            Dialog.confirm({
                title: '清空重扫',
				confirmButtonText: '确定',
				cancelButtonText: '取消',
                message: '确认进行清空重扫操作吗？',
            })
            .then(() => {
                ClearScanAllBoxInfo({loadCarInfoID:this.list.loadCarInfoID}).then(res=>{
                    if (res.status === 200) {
                        this.showsound(true);
                        that.getDetail()
                        that.isAllSendBox = false
                        Toast.success(res.msg);
                    } else {
                        this.showsound(false);
                        Toast.fail(res.msg);
                    }
                })
            })
            .catch(() => {
                // on cancel
            });
        },
        
		deleteImg(type) { 
            this.$set(this.imgObj,type,'')

            this.saveImgUrlArr.forEach((item,i)=>{
                const m = type.split('')[3]
                if(m == item.imageType){
                    this.saveImgUrlArr.splice(i,1)
                }
            })
		},

		changeImg() {
			const img = document.getElementsByClassName('img')[0]

            if(!img.files.length) return
			    
            this.handleFiles(img.files)

			let imgList = [...img.files]

			this.imgFiles.push(...imgList)
            
			this.submitImg()
		},

		chooseImage(num) {
            this.currentImg = num
            document.getElementsByClassName('img')[0].value = ''
			document.getElementsByClassName('img')[0].click()
		},

		// 预览图片
		previewImage(url) {
			ImagePreview({
				images: [url],
				closeable: true,
			});
		},

		handleFiles(files) {
			const that = this

            var file = files;

            const { type, name } = file[0]

            var imageType = /^image\//;
            if (!imageType.test(type)) {
                return
            }

            var reader = new FileReader();
            reader.onload = function (e) {
                that.$set(that.imgObj,`img${that.currentImg}`,e.target.result)
            };
            reader.readAsDataURL(file[0]);
		},

		submitImg(){
			const that = this

			let formDatas = new FormData();

			this.imgFiles.forEach((i,index)=>{
				formDatas.append("files", i);
			});

			Toast.loading({
				message: '上传中...',
				forbidClick: true,
				overlay:true,
				duration:0
			});

			axios({
				url:`${BaseApiUrl}/Img/InsertFtpImage`,
				method: "post",
				data: formDatas,
				headers: { "Content-Type": "multipart/form-data"}
			}).then(res=>{
				Toast.clear()
				if(res.data.status === 200 && res.data.success){
					this.saveImgUrlArr.push({imageUrl:res.data.response[0].urlPath,imageType:this.currentImg})
					this.imgFiles = []
				}else{
					Toast.fail(res.data.msg);
				}
			})
		},

        toList(bool){
			const { loadCarInfoID } = this.list
			this.$router.push({ path: '/mobile/loadingList', query: { loadCarInfoID,isScan:bool } })
        },

        openOrclose(){
            this.isOpen=!this.isOpen;

        },

        handleImgRequired(){
            this.photoList.forEach((item,i)=>{
                item.forEach((item2,i2)=>{
                this.$set(this.photoList[i][i2],'required',false)
                if(this.curTransportType == '空运' && [1,7].includes(item2.id)){
                    this.$set(this.photoList[i][i2],'required',true)
                }
                if(this.curTransportType == '海运' && [1,2,6,7].includes(item2.id)){
                    this.$set(this.photoList[i][i2],'required',true)
                }
                })
            })
        }
	},
        
    watch:{
        'isAllSendBox':function(n,o){
            if(n === true){
                this.allSend()
            }
        }
    },
}
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.item-info {
	padding: 10px;
	font-size: 14px;
	background-color: #f2f2f2;
	.item-ul {
		.item-li {
			display: flex;
            align-content: flex-start;
			& > div {
				line-height: 25px;
                flex: 1;
				& > span {
					vertical-align: text-top;
                    &:first-child{
                        padding-right: 10px;
                        display: inline-block;
                    }
                    &:last-child{
                        color: #3d5064;
                    }
				}
				& > p {
                    line-height: 20px;
					vertical-align: middle;
                    color: #3d5064;
                    margin: 0;
				}
			}
		}
	}
}
.conventionalBox-info {
	font-size: 14px;
	.signInDetail-btnBox {
		background-color: #fbf9fe;
		padding: 10px;
		border-bottom: 1px solid #cccccc;
		li {
			line-height: 40px;
			white-space: nowrap;
			display: flex;
			align-items: baseline;
		}
		.volume {
			min-width: 10%;
			max-width: 27%;
			height: 22px;
			line-height: 22px;
			font-size: 12px;
			border: 0;
			background-color: #fbf9fe;
			border-bottom: 1px solid #757474;
			outline: none;
			margin: 0 5px;
			padding: 0 5px;
			box-sizing: border-box;
		}
		&:last-child{
			border-bottom: 0;
		}
	}
}
.submit-btn {
	width: 100%;
	height: 40px;
	border-radius: 5px;
	background-color: #169bd5;
	color: #fff;
	font-size: 18px;
	border: 0;
}
.hidden {
	display: none;
}
.addInfo{
    position: absolute;
    right: 1%;
    color: #027db4;
}
.p-title{
    font-weight: 600;
    margin-bottom: 0;
    padding-left: 10px;
    font-size: 14px;
}
.btn-other{
    height: 36px !important;
    min-width: 48% !important;
}
.add{
    border: 2px dashed #ccc;
    width: 100%;
    text-align: center;
    line-height: 15px;
    color: #ccc;
    margin: 5px 0;
}
.add:hover{
    border-color: rgb(151, 151, 151);
    color: rgb(151, 151, 151);
}
.btnBox-left{
    width: 100%;padding-right: 5px;
}
.btnBox-right{
    width: 100%;padding-left: 5px;
}
.search-box{
	text-align: center;
	padding: 3% 12% 1.5%;
}
::v-deep .van-col{
	text-align: center;
	background-color: #f2f2f2;
    height: 40px;
    line-height: 40px;
	font-size: 15px;
}
.list {
	.list-div{
		display: flex;
		height: 43px;
		line-height: 43px;
		border-bottom: 1px solid #ccc;
		&>p{
			flex: 1;
			text-align: center;
			margin: 0;
			&>.downInp{
				width: 55%;
				border: 1px solid #ccc;
				height: 80%;
				text-align: center;
			}
		}
	}
}

::v-deep .van-tabs__nav--card {
	margin: 0;
	border: 0;
}
::v-deep .van-tabs__nav,.van-tabs__nav--card {
    border-bottom: 1px solid #ccc !important;
}
.isAllSendBox{
    &>div{
        float: right;
        font-size: 13px;
    }
}
.noSend-list{
    border: 1px solid #908d8d;
    .noSend-list-item{
        border-bottom: 1px solid #908d8d;
        &:last-child{
            border-bottom: 0;
        }
        .noSend-list-left{
            background-color: #facd91;text-align:left;padding-left:30px;
        }
        .noSend-list-right{
            background-color: #35495e;color:#fff;
        }
    }
}

.putC_footer{
	margin-top:10%;padding: 0 3%;
}

.submit-btn {
	height: 40px;
	border-radius: 5px;
	background-color: #169bd5;
	color: #fff;
	font-size: 15px;
	border: 0;
    margin-bottom: 15px;
}

.clear-btn {
	background-color: #cccccc;
}

.sign-photo-box {
	margin: 5px 10px 10px;
	box-sizing: border-box;
	ul {
        display: flex;
        &>div{
            flex:1;
            display: flex;
            flex-direction: column;
            align-items: center;
            p{
                font-size: 13px;
            }
        }
		.sign-photo-item {
            width: 100px;
			height: 100px;
			border: 5px solid #ccc;
			box-sizing: border-box;
			position: relative;
			float: left;
			margin: 0 4.5% 4.5% 0;
			line-height: 127px;
			overflow: hidden;
			box-shadow: 0px 0px 7px -1px #cccccc;
            .delete-icon {
                position: absolute;
                background: red;
                color: #fff;
                width: 16px;
                height: 16px;
                top: 0px;
                right: 0px;
                line-height: 16px;
                font-size: 12px;
                border-radius: 16px;
                text-align: center;
            }
			.sign-photo-item-img{
				width: auto;
				height: 100%;
			}
		}
		.sign-photo-btn {
			display: inline-block;
			vertical-align: top;
            width: 100px;
			.photo {
				height: 100px;
				background-color: #faf9fc;
				position: relative;
				box-shadow: 0px 0px 7px -1px #cccccc;
				p {
					border: 1px dashed #ccc;
					padding: 10px;
					width: 50px;
					height: 50px;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					margin: 0;
					i {
						font-size: 40px;
						color: #ccc;
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}
		}

	}
}

.sign-photo-save {
	padding: 20px 10px;
}

@media screen and (max-width:350px) {
    .sign-photo-box ul .sign-photo-item{
        width: 85px;
        height: 85px;
    }
    .sign-photo-box ul .sign-photo-btn{
        width: 85px;
        .photo{
            height: 85px;
        }
    }
}
</style>